import { ServerErrorIcon, SettingsIcon, ShieldFile } from "@theprelude/ds";
import { Node, NodeProps } from "@xyflow/react";
import { BucketDataPoint } from "@/queries/control-monitor";
import { AggregateNode } from "./aggregate-node";

type BucketId = BucketDataPoint["id"];

const isControlFailures = (id: BucketId) => id.endsWith("-control-failures");

const isPolicyMisconfigurations = (id: BucketId) =>
  id.endsWith("-policy-misconfigurations");

const getIcon = (id: BucketId) => {
  if (isPolicyMisconfigurations(id)) {
    return ShieldFile;
  }
  if (isControlFailures(id)) {
    return ServerErrorIcon;
  }
  return SettingsIcon;
};

export type BucketNodeType = Node<BucketDataPoint, BucketDataPoint["type"]>;

export const BucketNode = ({ data }: NodeProps<BucketNodeType>) => {
  const Icon = getIcon(data.id);
  return <AggregateNode data={data} icon={<Icon />} hasParent />;
};
